import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Row } from "@tanstack/react-table";
import { TransactionListItemDto } from "../../../common/types/transaction";
import { useIsDateLocked } from "../../../hooks/useIsDateLocked";
import { LockIcon } from "../../../icons";
import styles from "./LockCell.module.scss";

interface Props {
    row: Row<TransactionListItemDto>;
}

export const LockCell: React.FC<Props> = ({ row }) => {
    const transaction: TransactionListItemDto = row.original;
    const isLocked = useIsDateLocked(transaction.entity.id, transaction.date);

    if (!isLocked) {
        return null;
    }

    return (
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip id="lock-tooltip">
                    This transaction has been locked.
                    <br />
                    To unlock, go to <strong>Settings &gt; Locks</strong>
                </Tooltip>
            }
        >
            <span
                className={styles.value}
                data-testid="transaction-list-item-lock"
            >
                <LockIcon className="icon-color-current" />
            </span>
        </OverlayTrigger>
    );
};
